<template>
  <span class="float-right small">
    <a @click.prevent="clearFacets" class="text-decoration-none clickable">
      <i class="material-icons">clear</i> Clear filter
    </a>
  </span>
</template>

<script>
// scripts

import { createWidgetMixin } from 'vue-instantsearch';

export default {
  mixins: [createWidgetMixin({ connector: true })],
  data() {
    return {
    };
  },
  watch: {
    showDeactivated() {
      this.$store.dispatch('toggleDeactivated', this.showDeactivated);
      const currState = this.instantSearchInstance.helper.getState();
      this.instantSearchInstance.helper.setState(currState).search();
    },
  },
  props: {
    attribute: {
      type: String,
      default: '',
    },
  },
  methods: {
    clearFacets(){
      const currState = this.instantSearchInstance.helper.getState();
      currState.disjunctiveFacetsRefinements[this.attribute] = [];
      this.instantSearchInstance.helper.setState(currState).search();
    }
  },
};
</script>
